!function(window) {
function stackedAreaChart(options) {

	options.charts.stackedArea.validateFilter()

	// bind filter events 
	var $filterWrapper = $('.iopr-data-wrapper .filter-wrapper.stacked-area').on('submit', 'form', function (ev) {
		ev.preventDefault();
		options.html.stackedArea.filterForm.find('button[type="submit"]').prop('disabled', true);
		handleStackedAreaFilter();
	});

	// because filter option is disabled by default
	// we need to check dropdown change event and enable it if needed
	$filterWrapper.find('.iopr-select').on('changed.bs.select', function (e) {
		options.charts.stackedArea.validateFilter();
	});

	function handleStackedAreaFilter() {

		// TODO: at echarts
		options.methods.triggerStartProcessing('stackedArea');

		//show loader
		// hide previous data
		if (!options.html.stackedArea.chartData.hasClass('not-shown')) {
			options.html.stackedArea.chartData.fadeOut(function () {
				options.html.stackedArea.chartData.addClass('not-shown');
				options.html.stackedArea.chartData.html('');
			});
		}
		// show loader
		if (options.html.stackedArea.chartLoader.hasClass('not-shown')) {
			options.html.stackedArea.chartLoader.fadeIn(function () {
				options.html.stackedArea.chartLoader.removeClass('not-shown');

				var ajaxBody = setStackedChartAjaxBody(options.html.stackedArea.filterForm);

				$.post(options.base.apiIncludeLng(), ajaxBody, function (data) {

					// DO STUFF WITH BODY CALL GOOGLE
					var dataJson = JSON.parse(data);


					options.data.stackedArea.baseSeries = dataJson.series;
					options.data.stackedArea.googleSeries =
						google.visualization.arrayToDataTable(options.data.stackedArea.baseSeries);

					var formatter = new google.visualization.NumberFormat({
						suffix: ' €'
					});

					// first column is label so we format only value columns which number is dynamic
					// so this is why we use for
					if (options.data.stackedArea.baseSeries.length > 1 && options.data.stackedArea.baseSeries[0].length > 1) {
						for (var i = 1; i < options.data.stackedArea.baseSeries[0].length; i++) {
							formatter.format(options.data.stackedArea.googleSeries, i); // Apply formatter to second column
						}
					}


					options.charts.stackedArea.options = dataJson.options;

					//options.charts.stackedArea.options = dataJson;


					if (options.charts.stackedArea.chart) {
						options.charts.stackedArea.chart.clearChart();
					}
					// based on prepared DOM, initialize echarts instance

					if (dataJson.series == null || !dataJson.series.length) {
						options.methods.triggerEndProcessing('stackedArea');

					} else {
						options.charts.stackedArea.chart = new google.visualization.AreaChart(options.html.stackedArea.chartData[0]);
						options.charts.stackedArea.resize = () => options.charts.stackedArea.chart.draw(options.data.stackedArea.googleSeries, options.charts.stackedArea.options);

						google.visualization.events.addListener(options.charts.stackedArea.chart, 'ready', () => {
							options.methods.triggerEndProcessing('stackedArea');
						});

					}

					// show loader
					if (!options.html.stackedArea.chartLoader.hasClass('not-shown')) {
						options.html.stackedArea.chartLoader.fadeOut(function () {
							options.html.stackedArea.chartLoader.addClass('not-shown');
							options.html.stackedArea.chartData.fadeIn(function () {
								options.html.stackedArea.chartData.removeClass('not-shown');
								// use configuration item and data specified to show chart


								options.charts.stackedArea.chart.draw(options.data.stackedArea.googleSeries, options.charts.stackedArea.options);

								if (dataJson.series && dataJson.series.length) {
									// TODO: PUT THIS IN FUNCTION
									var columns = [];
									var series = {};
									for (var i = 0; i < options.data.stackedArea.googleSeries.getNumberOfColumns(); i++) {
										columns.push(i);
										if (i > 0) {
											series[i - 1] = {};
										}
									}


									google.visualization.events.addListener(options.charts.stackedArea.chart, 'select', function () {
										var sel = options.charts.stackedArea.chart.getSelection();
										// if selection length is 0, we deselected an element
										if (sel.length > 0) {
											// if row is undefined, we clicked on the legend
											if (sel[0].row === null) {
												var col = sel[0].column;
												if (columns[col] == col) {
													// hide the data series
													columns[col] = {
														label: options.data.stackedArea.googleSeries.getColumnLabel(col),
														type: options.data.stackedArea.googleSeries.getColumnType(col),
														calc: function () {
															return null;
														}
													};

													// grey out the legend entry
													series[col - 1].color = '#CCCCCC';
												} else {
													// show the data series
													columns[col] = col;
													series[col - 1].color = null;
												}
												var view = new google.visualization.DataView(options.data.stackedArea.googleSeries);
												view.setColumns(columns);
												var optionsWithSeries = Object.assign({}, options.charts.stackedArea.options);
												optionsWithSeries.series = series;
												options.charts.stackedArea.chart.draw(view, optionsWithSeries);
											}
										}
									});

									// TODO: HERE IT ENDS
								}

							});
						});
					}

				});
			});
		}

		function setStackedChartAjaxBody($form) {
			// get year
			var obj = {};
			obj['cashFlow'] = options.properties.cashFlow;
			obj['type'] = options.properties.type;
			obj['dataType'] = 'stacked-area';
			if (options.properties.type == 'month') {
				obj['period'] = $form.find('input[name="helper-period"]').val();
			}
			// because saving as value/field
			obj['parentId'] = options.properties.parent.id;
			obj['from'] = options.html.stackedArea.periodFrom.val();
			obj['to'] = options.html.stackedArea.periodTo.val();
			obj['excluded'] = options.properties.excluded;
			return obj;
		}

	}



	// diplsay of tooltip

	function formatTooltipHeader(params) {
		return '<div style="font-size: 1.2em; margin-bottom: 5px;"><b>' + params[0].name + '</b></div>';
	}

	// function formatTooltipLabel(params) {
	// 	let lbl = '<div style="display: table;">';
	// 	lbl += '	<div style="display: table-row;">';
	// 	lbl += '		<div style="display:table-cell; vertical-align:middle; padding-right: 5px;">';
	// 	lbl += '			<div style="border-radius: 50%; width: 10px; height: 10px; background-color: ' + params.color + ';"></div>'
	// 	lbl += '		</div>';
	// 	lbl += '		<div style="display:table-cell; verical-align:middle;">';
	// 	lbl += `			${params.seriesName}: ${params.data[params.dataIndex]} €`;
	// 	lbl += '		</div>';
	// 	lbl += '	</div>';
	// 	lbl += '</div>';
	// 	return lbl;
	// }

	options.charts.stackedArea.generate = handleStackedAreaFilter;
}


module.exports = stackedAreaChart;
window.stackedAreaChart = stackedAreaChart;
}(window);